import AddPartner from './AddPartner'
import {connect} from 'react-redux';
import * as action from '../../state/detail/action'
import * as selector from '../../state/detail/selector'
import {selectStoreList} from "../../../globals/state/selector";

const mapStateToProps = (state) => {
    return {
        title:'Add Partner',
        partner: selector.selectPartner(state),
        storeList: selectStoreList(state),
        error: selector.selectError(state),
        validationMessageList: selector.selectValidationMessageList(state),
        redirect:selector.selectRedirect(state)
    }
}

const mapDispatchToProps = {
    editPartner: action.editPartnerFormValue,
    savePartner: action.savePartner,
    pushValidationList: action.pushValidationList,
    clearState:action.clearState,
}

export default connect(mapStateToProps, mapDispatchToProps)(AddPartner)


// WEBPACK FOOTER //
// ./src/modules/partner/component/add/AddPartnerContainer.js